import { FC, useEffect, useState } from "react";
import ezgif from "../../assets/ezgif1.png";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SetupDID from "../../components/SetupDID/SetupDID";
import { Persona } from "@funded-here-interface/common/src/constant/enum";
import { useStyle } from "./DirectorDIDSetup.styles";
import OnboardingLayout from "../../layouts/OnboardingLayout/OnboardingLayout";
import useGetUser from "@funded-here-interface/common/src/hooks/useGetUser";
import { REGISTER_LUMINOR_DID_QUERY_ID } from "../../constants/domain";
import WipOnboardingLayout from "../../layouts/OnboardingLayout/WipOnboardingLayout";
import { Button, Flex, Modal } from "@mantine/core";
import useOverwriteName from "../../hooks/useOverwriteName";
import useCompleteOnboarding from "../../hooks/useCompleteOnboarding";
import { navigateToThanksPage } from "../ThanksPage/ThanksPageUtils";
import { ThanksPageType } from "../../constants/enums";

const DirectorDIDSetup: FC = () => {
  const { classes } = useStyle();
  const [isLoading, setIsLoading] = useState(false);
  const Navigate = useNavigate();
  const { userId, role, token, spvName } = useSelector(
    (state: RootState) => state.auth
  );
  const useCompleteOnboardingMutation = useCompleteOnboarding();
  // const getUserMutation = useGetUser();
  const { data, error, refetch } = useGetUser(token);
  const [counter, setCounter] = useState(0);
  const [nameModal, setNameModal] = useState<boolean>(false);
  const overwriteNameMutation = useOverwriteName();
  const [overwriteBtnLoading, setOverwriteBtnLoading] =
    useState<boolean>(false);

  if (error) {
    setIsLoading(false);
    toast.error((error as Error).message);
  }

  const onInit = (data: any) => {
    console.log("onInit", data.detail);
  };

  const onScan = (data: any) => {
    setIsLoading(true);
    const response = data.detail;
    if (response.query_id === REGISTER_LUMINOR_DID_QUERY_ID) {
      setTimeout(() => {
        setIsLoading(false);
        scanCompletedRouting();
      }, 2000);
    }

    const result = JSON.parse(response.result);
    const ledgerAddress = result.qrRes
      .split("LedgerAddress= ")[1]
      .split(",")[0];

    if (!ledgerAddress) {
      toast.error("ledgerAddressKey is not present");
    }

    setCounter(0);
    refetch();
  };

  useEffect(() => {
    if (data?.didRegistrationId === null && !data?.didErrorMsg) {
      const interval = setInterval(() => {
        setCounter((prevCounter) => prevCounter + 1);

        refetch();
      }, 3000); // Adjust the interval as needed

      if (counter > 20) {
        toast.error("Server is busy. Please refresh and try again");
        setIsLoading(false);

        clearInterval(interval);
      }

      return () => clearInterval(interval); // Clear interval on component unmount
    }
    if (data?.didRegistrationId && data?.didRegistrationId !== null) {
      scanCompletedRouting();
    }

    if (data?.didErrorMsg) {
      toast.error(data?.didErrorMsg ?? "DID Registration failed");
      setIsLoading(false);

      if (data?.didErrorMsg.includes("Name does not match")) {
        setNameModal(true);
      }
    }
  }, [data, refetch, counter]);

  const scanCompletedRouting = () => {
    if (role === Persona.MERCHANT) {
      useCompleteOnboardingMutation.mutate(
        { token },
        {
          onSuccess: () => {
            navigateToThanksPage(Navigate, ThanksPageType.BOARDING_RESOLUTION);
          },
          onError: (e) => {
            toast.error((e as Error).message);
          },
        }
      );
    } else {
      Navigate("/director-board-resolution", {
        state: { skipDidVerify: true },
      });
    }
  };

  return (
    <WipOnboardingLayout
      step={0}
      content={
        <div>
          {isLoading && (
            <div className={classes.loadingScreen}>
              <img className={classes.loadingIcon} src={ezgif} alt="" />
            </div>
          )}

          <SetupDID
            header="ID Setup"
            onInit={onInit}
            onScan={onScan}
            id={userId}
          />
        </div>
      }
    />
  );
};

export default DirectorDIDSetup;
